module.exports = __webpack_public_path__ + "static/media/fb.ba5bbf46.png";